import {
   API_FETCHING,
   API_SUCCESS,
   API_INITIAL,
   API_FAILED,
   APIStatus,
   API_FETCHING_PAGINATION
} from '../constants'

export function isAPISuccess(...args): boolean {
   const status = true
   return Array.from(args).reduce(
      (returnStatus, item) =>
         returnStatus && parseInt(item, 10) === API_SUCCESS,
      status
   )
}

export function isAPIFailed(...args): boolean {
   return Array.from(args).indexOf(API_FAILED) !== -1
}

export function isAPIFetching(...args): boolean {
   const status = false
   return Array.from(args).reduce(
      (returnStatus, item) =>
         returnStatus || parseInt(item, 10) === API_FETCHING,
      status
   )
}

export function isAPIInitial(...args): boolean {
   const status = false
   const initialStatus = Array.from(args).reduce(
      (returnStatus, item) =>
         returnStatus || parseInt(item, 10) === API_INITIAL,
      status
   )
   return initialStatus
}

export function isAPIFetchingPagination(...args): boolean {
   const status = false
   return Array.from(args).reduce(
      (returnStatus, item) =>
         returnStatus || parseInt(item, 10) === API_FETCHING_PAGINATION,
      status
   )
}

export function getLoadingStatus(...args): APIStatus {
   if (isAPISuccess(...args)) {
      return API_SUCCESS
   } else if (isAPIFailed(...args)) {
      return API_FAILED
   } else if (isAPIFetching(...args)) {
      return API_FETCHING
   } else if (isAPIInitial(...args)) {
      return API_INITIAL
   }
   return API_SUCCESS
}
